import SystemConstants from 'src/app/util/constants/SystemConstants';
import { Component, HostListener } from "@angular/core";
import * as AOS from "aos";
import { Router, NavigationEnd } from "@angular/router";
import { Globals } from "./globals/globals";
import { IGlobals } from "./globals/custom-types/global-custom-types";
import { LocalizationService } from "./util/service/internationalization/localization.service";
import { Translations } from 'src/app/util/service/internationalization/translations.service';
import { AuthService } from "./model/auth-model/auth.service";
import { UserRole } from "./globals/globals";
import { CustomConfirmationPopupService } from './user/shared/components/custom-confirmation-popup-component/custom-confirmation-popup.service';
import { Subscription } from 'rxjs';
import { UserHeaderUiStateService } from 'src/app/user/shared/services/user-header-ui-state.service';
import { UserCommonService } from './user/shared/utils/user-common.service';
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent {
 systemConstants = SystemConstants;
  addSlideCls = false;
  currentUrl: any;
  showUserHeader = false;
  showAdminHeader = true;
  showMasqueradeOverlay = false;
  fold: any = [
    {
      id: "5b3debc88cc1a81eac86cdf4",
      foldName: "Slider ",
      foldTypeId: "5b0e697164b15f11a0bc0ad5",
      auth: 21,
      data: [],
      foldType: {
        id: "5b0e697164b15f11a0bc0ad5",
        foldTypeName: "Slider",
        dataComponent: "ManageHeroComponent",
        frontComponent: "HeroSliderComponent",
        status: 1,
        created: "2018-05-30T08:56:13.871Z",
        modified: "2018-05-30T08:56:13.871Z",
      },
    },
    {
      id: "5b4342f96d78ec20b860abc2",
      foldName: "BENEFITS OF CORPORATE ACCOUNT",
      foldTypeId: "5b3e10a70e1ff54812000039",
      auth: 21,
      data: [],
      foldType: {
        id: "5b3e10a70e1ff54812000039",
        foldTypeName: "Right Image Fold",
        dataComponent: "ManageImageComponent",
        frontComponent: "EarnWellBuxFoldComponent",
        status: 1,
        created: "2018-05-30T08:56:13.871Z",
        modified: "2018-05-30T08:56:13.871Z",
      },
    },
    {
      id: "5b4345426d78ec20b860abc3",
      foldName: "BENEFITS OF EXHIBITOR ACCOUNT ",
      foldTypeId: "5b4343160e1ff57812000029",
      auth: 21,
      data: [],
      foldType: {
        id: "5b4343160e1ff57812000029",
        foldTypeName: "Left Image Fold",
        dataComponent: "ManageImageComponent",
        frontComponent: "BenefitsOfMerchantFoldComponent",
        status: 1,
        created: "2018-05-30T08:56:13.871Z",
        modified: "2018-05-30T08:56:13.871Z",
      },
    },
    {
      id: "5b446b52aacc2d2ee8dce1b5",
      foldName: "About Us",
      foldTypeId: "5b4345cf0e1ff5781200002a",
      auth: 21,
      data: [],
      foldType: {
        id: "5b4345cf0e1ff5781200002a",
        foldTypeName: "About us",
        dataComponent: "ManageImageComponent",
        frontComponent: "AppFeaturesFoldComponent",
        clientSchema: [
          {
            heading: "",
            sub_heading: "",
            description: "",
            type: "",
            file: [],
          },
        ],
        status: 1,
        created: "2018-05-30T08:56:13.871Z",
        modified: "2018-05-30T08:56:13.871Z",
      },
    },
    {
      id: "5b446b52aacc2d2ee8dce1b5",
      foldName: "About Us",
      foldTypeId: "5b4345cf0e1ff5781200002a",
      auth: 21,
      data: [],
      foldType: {
        id: "5b4345cf0e1ff5781200002a",
        foldTypeName: "About us",
        dataComponent: "ManageImageComponent",
        frontComponent: "AboutWellbuxVedioFoldComponent",
        clientSchema: [
          {
            heading: "",
            sub_heading: "",
            description: "",
            type: "",
            file: [],
          },
        ],
        status: 1,
        created: "2018-05-30T08:56:13.871Z",
        modified: "2018-05-30T08:56:13.871Z",
      },
    },
  ];
  isOnline: boolean = navigator.onLine;
  addChallengeBarActive = false;
  showWbxMenu = false;
  private addChallengeBarSub: Subscription | null = null;
  private menuOpen: Subscription | null = null;
  constructor(
    private router: Router,
    public globals: Globals,
    public localizationService: LocalizationService,
    public translations:Translations,
    private authService: AuthService,
    private confirmationService: CustomConfirmationPopupService,
    private userHeaderUiStateService: UserHeaderUiStateService,
    private userCommonService:UserCommonService
    ) {
    this.localizationService.initializeLocalizationDefaults();

    this.addChallengeBarSub =
      this.userHeaderUiStateService.addChallengeActive$.subscribe((isActive) => {
        this.addChallengeBarActive = isActive;
      });

    this.menuOpen = this.userHeaderUiStateService.mobileMenuOpen$.subscribe((isOpen) => {
      this.showWbxMenu = isOpen;
    });
     

    // this is use for non-auth route manager
    let routeBackHistory = [];
    let currentUrl;
    let routeUrl: IGlobals['unAuthRoute'];
    this.router.events.subscribe((val) => {
      if (this.authService.isAuthenticated() && val instanceof NavigationEnd) {
        routeBackHistory.push(val.url); //get router link /user
        routeUrl = this.globals.unAuthRoute as IGlobals['unAuthRoute'];
        currentUrl = this.router.url;
        routeUrl = routeUrl.filter((x) => x.value === currentUrl);
        if (routeUrl.length > 0) {
          routeBackHistory.pop();
        }
        if (routeBackHistory.length >= 0 && routeBackHistory.length <= 2) {
          if (routeUrl.length > 0) {
            //this.spinner.show();
            setTimeout(() => {
              this.router.navigateByUrl(localStorage.getItem("backUrl"));
              // this.spinner.hide();
            }, 200);
          }
        }
        // if (routeBackHistory.length > 1) {
        if (routeBackHistory.length > 2) {
          localStorage.setItem(
            "backUrl",
            routeBackHistory[routeBackHistory.length - 1]
          );
          if (routeUrl.length > 0) {
            //this.spinner.show();
            setTimeout(() => {
              this.router.navigateByUrl(localStorage.getItem("backUrl"));
              // this.spinner.hide();
            }, 200);
          }
        }
      }
    });
    // this is use for non-auth route manager
  }

  // @HostListener('window:popstate', ['$event'])
  // onPopState(event: any): void {
  //   localStorage.setItem("backUrl", this.currentUrl);
  //   window.location.href = this.currentUrl
  //   event.preventDefault();
  // }

  ngOnInit() {
    
    window.addEventListener('online', () => {
      this.isOnline = true;
    });

    window.addEventListener('offline', () => {
      this.isOnline = false;
    });

    AOS.init({
      disable: "mobile",
    });
    if (this.authService.isAuthenticated()) {
      this.userCommonService.loadCurrentUser();
    }
    // Update header visibility on initial load
    this.updateHeaderVisibility(this.router.url);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let path = event.url.replace("/", "");
        this.currentUrl = path;
        
        // Check if we should show user-header (only for USER role on /user route)
        this.updateHeaderVisibility(event.url);
        
        if (!path) {
          path = "home";
        } else if (path == "signup") {
          this.fold = [
            {
              id: "5b446b52aacc2d2ee8dce1b5",
              foldName: "About Us",
              foldTypeId: "5b4345cf0e1ff5781200002a",
              auth: 21,
              data: [],
              foldType: {
                id: "5b4345cf0e1ff5781200002a",
                foldTypeName: "About us",
                dataComponent: "ManageImageComponent",
                frontComponent: "SignUpComponent",
                clientSchema: [
                  {
                    heading: "",
                    sub_heading: "",
                    description: "",
                    type: "",
                    file: [],
                  },
                ],
                status: 1,
                created: "2018-05-30T08:56:13.871Z",
                modified: "2018-05-30T08:56:13.871Z",
              },
            },
          ];
        } else if (path == "fold") {
          this.fold = [
            {
              id: "5b446b52aacc2d2ee8dce1b5",
              foldName: "About Us",
              foldTypeId: "5b4345cf0e1ff5781200002a",
              auth: 21,
              data: [],
              foldType: {
                id: "5b4345cf0e1ff5781200002a",
                foldTypeName: "About us",
                dataComponent: "ManageImageComponent",
                frontComponent: "ManageFoldComponent",
                clientSchema: [
                  {
                    heading: "",
                    sub_heading: "",
                    description: "",
                    type: "",
                    file: [],
                  },
                ],
                status: 1,
                created: "2018-05-30T08:56:13.871Z",
                modified: "2018-05-30T08:56:13.871Z",
              },
            },
          ];
        } else if (path == "login") {
          this.fold = [
            {
              id: "5b446b52aacc2d2ee8dce1b5",
              foldName: "About Us",
              foldTypeId: "5b4345cf0e1ff5781200002a",
              auth: 21,
              data: [],
              foldType: {
                id: "5b4345cf0e1ff5781200002a",
                foldTypeName: "About us",
                dataComponent: "ManageImageComponent",
                frontComponent: "LoginComponent",
                clientSchema: [
                  {
                    heading: "",
                    sub_heading: "",
                    description: "",
                    type: "",
                    file: [],
                  },
                ],
                status: 1,
                created: "2018-05-30T08:56:13.871Z",
                modified: "2018-05-30T08:56:13.871Z",
              },
            },
          ];
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.addChallengeBarSub?.unsubscribe();
    this.menuOpen?.unsubscribe();
  }

  updateHeaderVisibility(url: string): void {
    const userData = this.authService.getUserData();
    const userRole = userData?.data?.role;

    const onUserShell =
      url === '/user' || url.startsWith('/user/');
    const rolesWithUserHeaderOnUserRoute: number[] = [
      UserRole.USER,
      UserRole.SUPER_ADMIN,
      UserRole.LOCALE_ADMIN,
    ];
    const useUserHeaderOnUserRoute =
      onUserShell &&
      userRole != null &&
      rolesWithUserHeaderOnUserRoute.includes(userRole);

    if (useUserHeaderOnUserRoute) {
      this.showUserHeader = true;
      this.showAdminHeader = false;
    } else {
      this.showUserHeader = false;
      this.showAdminHeader = true;
    }

    const isAdminPortalUser =
      userRole === UserRole.SUPER_ADMIN || userRole === UserRole.LOCALE_ADMIN;
    this.showMasqueradeOverlay = Boolean(
      this.authService.isAuthenticated() && isAdminPortalUser && !onUserShell
    );

    // Same body class for admin top bar OR user-dashboard masquerade (user-header bar).
    const masqueradeSessionActive = this.isMasqueradeSessionActive();
    document.body.classList.toggle(
      'wbx-user-masquerade',
      this.showMasqueradeOverlay || masqueradeSessionActive
    );
  }

  private isMasqueradeSessionActive(): boolean {
    return (
      localStorage.getItem('masqueradeActive') === 'true' &&
      Boolean(localStorage.getItem('masqueradeAdminToken'))
    );
  }

  onExitAdminPanelClick(event: Event): void {
    event.preventDefault();
    this.confirmationService.open({
      title: 'User panel',
      message: 'Go to the user panel?',
      type: 'warning',
      yesText: 'Yes',
      noText: 'No', 
      onConfirm: () => {
        localStorage.setItem('backUrl', '/user');
        void this.router.navigateByUrl('/user/user-profile?tab=programs');
      },
    });
  }

  get masqueradeOverlayText(): string {
    return this.systemConstants.ADMIN_PANEL_TEXT ;
  }
}
